import { Link } from "react-router-dom";
import { categories, aboutInfo } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-black text-primary-400 tracking-tight">
                黑料<span className="text-background-100">官网</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              还原事实真相，传递真实声音。国内领先的真实黑料爆料与娱乐资讯聚合平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">关于我们</Link></li>
              <li><Link to="/category/mingxing" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">明星黑料</Link></li>
              <li><Link to="/category/neimu" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">独家内幕</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-line text-xs"></i></span>
                {aboutInfo.contact.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-wechat-line text-xs"></i></span>
                {aboutInfo.contact.wechat}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-weibo-line text-xs"></i></span>
                {aboutInfo.contact.weibo}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 黑料官网. 版权所有.
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}